module.exports = __webpack_public_path__ + "img/04_kii_05.92b846dd.jpg";